<div
  *transloco="let t; prefix: 'widgets.journey-analytic-item-selector-dialog'"
  class="xi-modal__container journey-analytic-item-selector__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('analytic-items') }}</h2>

  <div class="xi-modal__content">
    <app-numeric-metadata-field-selector
      [fields]="numericFields()"
      [journeyMode]="true"
      [rows]="options().widget.payload.numericMetadataFields"
      [hasSettings]="false"
      [canSetColor]="false"
      [canSetDecimals]="false"
      [sentimentScale]="options().sentimentScale"
      (valueChange)="onNumericMetadataFieldsChanged($event)"
      (isValid)="onNumericMetadataFieldsIsValid($event)"
    ></app-numeric-metadata-field-selector>
  </div>

  <div class="xi-modal__actions journey-analytic-item-selector__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [disabled]="!isValid()"
      [text]="t('apply')"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
